<template>
  <div class="airMenuCom">
    <el-input
      placeholder="请输入关键字"
      v-model="filterText"
      clearable
    ></el-input>
    <el-radio-group
      v-model="active"
      size="mini"
      style="margin: 12px 0"
      @change="changeActive"
    >
      <el-radio-button
        v-for="(v, i) in treeList"
        :key="i"
        :label="v.name"
      ></el-radio-button>
    </el-radio-group>
    <div class="menuContent">
      <el-tree
        v-if="active == '末端'"
        :data="treeData"
        :props="defaultProps"
        accordion
        :default-expanded-keys="defaultKeys"
        :filter-node-method="filterNode"
        node-key="id"
        highlight-current
        ref="tree"
        style="
          overflow: auto;
          background: #f7f7f7;
          border: 1px solid #e7e7e7;
          border-radius: 6px;
          padding: 10px 0;
          height: 90%;
        "
      ></el-tree>
      <ul class="listBox" v-else>
        <template v-if="filterFruitList.length">
          <li
            v-for="(v, i) in filterFruitList"
            :key="i"
            :class="{ activetItem: activeLi.id == v.id }"
            @click="activeLi = v"
          >
            <p>{{ v.name }}</p>
            <span v-if="active == '机房'">
              {{ !v.active ? "——" : v.energyType == "cool" ? "制冷" : "制热" }}
            </span>
            <span v-if="active == '策略' && v.underExecution" class="colorSpan">
              正在执行
            </span>
          </li>
        </template>
        <el-empty v-else description="暂无数据"></el-empty>
      </ul>
    </div>
    <div class="buttons">
      <el-button type="primary" @click="onSubmit">确 认 </el-button>
      <el-button type="danger" v-if="active == '策略'" @click="deleteStrategy"
        >删除</el-button
      >
    </div>
  </div>
</template>

<script>
import api from "@/api";
export default {
  data() {
    return {
      filterText: "",
      active: "",
      treeData: [],
      defaultKeys: [], //默认打开
      defaultProps: {
        children: "children",
        label: "name",
      },
      listData: [],
      activeLi: {},
      treeList: [],
    };
  },
  watch: {
    filterText(val) {
      if (this.active == "末端") {
        this.$refs.tree.filter(val);
      }
    },
  },
  computed: {
    filterFruitList() {
      return this.listData.filter((item) => {
        return item.name.indexOf(this.filterText) !== -1;
      });
    },
  },
  methods: {
    onSubmit() {
      if (
        (this.active == "末端" && !this.$refs.tree.getCurrentKey()) ||
        (this.active == "机房" && !this.activeLi.id)
      ) {
        this.$message.error("请选择资产");
        return;
      }
      this.handleEmit();
    },
    handleEmit() {
      this.$emit("getActiveItem", {
        treeActive:
          this.active == "末端"
            ? this.$refs.tree.getCurrentNode()
            : this.activeLi,
        active: this.active,
      });
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    changeActive() {
      this.filterText = "";
      this.activeLi = {};
      this.listData = [];
      if (this.active == "机房") {
        this.getMachineRoom();
      } else if (this.active == "策略") {
        this.getStrategyList();
      } else if (this.active == "末端") {
        this.getTreeDefaultData();
      }
    },
    async getAsseList() {
      let res = await api.lightSystemAssetsTreeMenu({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        projectName: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectName,
        option: "HasEUDevice",
        deviceType: "风机盘管,分体式空调",
      });
      if (res?.status == 200) {
        this.treeData = res.data.assets?.区域位置
          ? [res.data.assets.区域位置]
          : [];
        this.getTreeDefaultData();
      }
    },
    getTreeDefaultData() {
      let _this = this;
      this.defaultData = this.treeData[0];
      this.$nextTick(() => {
        this.$refs.tree.setCurrentKey(_this.defaultData.id);
        this.defaultKeys.push(_this.defaultData.id);
        this.handleEmit();
      });
    },
    // 获取机房列表
    async getMachineRoom() {
      this.$store.commit("SET_LOADING", true);
      let res = await api.ACRGetCentralAirConditioning({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        deviceType: "中央空调主机,锅炉,空气源热泵",
      });
      if (res && res.data.code == 200) {
        this.$store.commit("SET_LOADING", false);
        this.listData = res.data.data;
        this.activeLi = this.listData[0];
        this.handleEmit();
      }
    },
    // 获取策略列表
    async getStrategyList() {
      this.$store.commit("SET_LOADING", true);
      let res = await api.ACRGetStrategyList({});
      // console.log(res);
      if (res && res.data.code == 200) {
        this.$store.commit("SET_LOADING", false);
        this.listData = res.data.data;
        // this.listData = [];
        this.activeLi = this.listData[0];
        this.handleEmit();
      }
    },
    // 删除策略
    deleteStrategy() {
      if (this.activeLi.id) {
        if (this.active.underExecution) {
          this.$confirm("当前策略正在执行，不可删除", "删除策略", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {})
            .catch(() => {});
        } else {
          this.$confirm("删除后该策略不可恢复", "删除策略", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.handleDelete();
            })
            .catch(() => {});
        }
      }
      return;
    },
    async handleDelete() {
      let res = await api.ACRDeleteStrategy({}, this.activeLi.id.id);
      if (res && res.data.code == 200) {
        this.$message.success("删除成功!");
        this.getStrategyList();
      }
    },

    async getTreeList() {
      let res = await api.backstageGetList({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        pageName: "strategy",
      });
      if (res?.status == 200) {
        if (res.data.length && res.data[0].additionalInfo?.length) {
          this.treeList = res.data[0].additionalInfo;
          this.active = this.treeList[0].name;
        } else {
          this.handleDefTree();
        }
      } else {
        this.handleDefTree();
      }
    },
    handleDefTree() {
      this.treeList = [{ name: "末端" }, { name: "机房" }, { name: "策略" }];
      this.active = this.treeList[0].name;
    },
  },

  created() {
    this.getTreeList();
    this.getAsseList();
  },
  mounted() {
    this.$bus.$on("getClickAssetsItem", (item) => {
      if (item.entityId) {
        this.defaultKeys = [];
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(item.entityId);
          this.defaultKeys.push(item.entityId);
          this.handleEmit();
        });
      }
    });
  },
  beforeDestroy() {
    this.$bus.$off("getClickAssetsItem");
  },
};
</script>

<style lang="scss" scoped>
.airMenuCom {
  width: 93%;
  height: 93%;
  margin: 5% auto;
  .menuContent {
    width: 100%;
    height: 70%;
    // background: sandybrown;
    ::v-deep
      .el-tree--highlight-current
      .el-tree-node.is-current
      > .el-tree-node__content {
      background-color: $themeColor !important;
      color: #fff;
    }
    .listBox {
      height: 100%;
      background: #f7f7f7;
      border: 1px solid #e7e7e7;
      border-radius: 6px;
      overflow: auto;
      li {
        width: 90%;
        margin: 10px auto;
        line-height: 30px;
        cursor: default;
        text-indent: 15px;
        @include setFlexBetween;
        span {
          margin-right: 10px;
        }
        .colorSpan {
          color: #28cccb;
          font-weight: bold;
        }
      }
      li:hover {
        background: rgba(40, 204, 203, 0.5);
        color: #fff;
        .colorSpan {
          color: #fff;
        }
      }
      .activetItem {
        background: #28cccb !important;
        color: #fff;
        .colorSpan {
          color: #fff;
        }
      }
    }
  }
  .buttons {
    width: 55%;
    margin: 20px auto;
    @include setFlexCenter;
  }
}
</style>
